import 'react-app-polyfill/stable'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
// import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { BrowserRouter } from 'react-router-dom'

import { persistor, store } from './config/redux'
import LanguageContextProvider from './context/LanguageContext'
// import { history } from './util/history'

import App from './App'

const EnhancedApp = () => (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}
            >
                <LanguageContextProvider>
                    <App />
                </LanguageContextProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>
)

const isDev = process.env.NODE_ENV === 'development'

/** React Strict will render the components twice in development mode (this behavior will not occur in production).
 * please check https://reactjs.org/docs/strict-mode.html */

const container = document.getElementById('root')
const root = createRoot(container)

const AppToRender = isDev ? (
    <EnhancedApp />
) : (
    <StrictMode>
        <EnhancedApp />
    </StrictMode>
)

root.render(AppToRender)
